module.exports = __webpack_public_path__ + "static/media/Decisions_Step2_Image13.06529110.jpg";